export enum ContentSourcePickerVariant {
  BrandVoiceImport = 'BrandVoiceImport',
  CampaignImport = 'CampaignImport',
}
